"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _CompletedContext = require("../CompletedContext");
var _Carousel = _interopRequireDefault(require("react-bootstrap/Carousel"));
require("./TaskCarousel.scss");
var TaskCarousel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskCarousel, _Component);
  var _super = (0, _createSuper2.default)(TaskCarousel);
  function TaskCarousel(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskCarousel);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = true; // this.props.completed || false
    }
    return _this;
  }
  (0, _createClass2.default)(TaskCarousel, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        style: this.props.style || {
          textAlign: "center",
          width: "100%"
        }
      }, /*#__PURE__*/_react.default.createElement(_Carousel.default, {
        className: "bdg-carousel",
        interval: null,
        "aria-live": "polite",
        prevLabel: "Previous Slide",
        nextLabel: "Next Slide"
      }, this.props.items.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(_Carousel.default.Item, null, item);
      })));
    }
  }]);
  return TaskCarousel;
}(_react.Component);
exports.default = TaskCarousel;
TaskCarousel.contextType = _CompletedContext.CompletedContext;